export default "__VITE_ASSET__Cl4RTHgE__"